"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var isMemberOfGroup = function (userProfile, group) {
    return StringUtils_1.isBlank(group) ||
        (userProfile && userProfile.user && userProfile.user.groups && userProfile.user.groups.some(function (g) { return g.name === group; }));
};
exports.isMemberOfGroup = isMemberOfGroup;
